import actionTypes from "../constants/actionTypes"

const initialState = {
    isLogin: false,
    isApprovalWaiting: false,
    isInfo: false,
    isAuth: null,
    id: null,
    name: "",
    role: null, // role 정보 추가
    msg: "",
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.LOGIN_CHECK_SUCCEED:
            return {
                ...state,
                isLogin: action.loginData.data.isLogin,
                id: action.loginData.data.id,
                name: action.loginData.data.name,
                isApprovalWaiting: action.loginData.data.isApprovalWaiting,
                isInfo: action.loginData.data.isInfo,
                role: action.loginData.data.role, // role 정보 저장
                isAuth: false,
            }
        case actionTypes.LOGIN_INFO_APPROVAL:
            return {
                ...state,
                isInfo: true,
            }
        case actionTypes.LOGIN_CHECK_FAILED:
            return {
                ...state,
                isAuth: false,
                id: null,
                name: "",
                role: null, // 로그인 실패 시 role 초기화
            }
        default:
            return state
    }
}
